package com.patronat.top.features.dashboard.data.repository

import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.asDomainResult
import com.patronat.top.dto.ReviewFilterRequest
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.features.dashboard.data.network.ReviewModerationRemoteDataStore
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository

class ReviewModerationRepositoryImpl(
    private val remoteDataStore: ReviewModerationRemoteDataStore
) : ReviewModerationRepository {

    override suspend fun getReviews(request: ReviewFilterRequest): DomainResult<ReviewListResponse> {
        return remoteDataStore.getReviews(request).asDomainResult { it }
    }

    override suspend fun moderateReview(reviewId: String, approved: Boolean): DomainResult<ReviewResponse> {
        return remoteDataStore.moderateReview(reviewId, approved).asDomainResult { it }
    }

    override suspend fun getMyVenueReviews(request: ReviewFilterRequest): DomainResult<ReviewListResponse> {
        return remoteDataStore.getMyVenueReviews(request).asDomainResult { it }
    }

    override suspend fun replyToReview(reviewId: String, text: String): DomainResult<ReviewResponse> {
        return remoteDataStore.replyToReview(reviewId, text).asDomainResult { it }
    }
}
